import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import { FDAlert, FDStack } from '@facet-wealth/design';
import PlannerAssignmentStepHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPostOnboardingWhatIsNext/PlannerAssignmentStepHeader';
import PlannerOptionCard
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingPlannerAssignmentSelectPlanner/PlannerOptionCard';


function OnboardingPlannerAssignmentSelectPlanner() {
  const {
    resource,
    onSubmit,
  } = useMetaLayoutContext();

  if (!resource) return null;

  return (
    <FDStack direction={'column'} spacing={2}>
      <PlannerAssignmentStepHeader resource={resource} />
      <FDStack paddingY={5} spacing={4} justifyContent={'center'} wrap>
        {resource.attr('plannerOptions').resources().list().map((option) => <PlannerOptionCard key={option.id} plannerOptionResource={option} onSubmit={onSubmit} />)}
      </FDStack>
      <FDAlert status={'info'} description={resource.attr('infoBoxDescription')} title={resource.attr('infoBoxTitle')} />
    </FDStack>
  );
}

export default OnboardingPlannerAssignmentSelectPlanner;
